import ContainerPainel from 'components/container_painel';
import { HorizontalStepper } from 'components/shared/horizontal_stepper';
import React, { useEffect, useState } from 'react';
import { ROUTES } from 'routes/constants';
import { PageTitle } from 'components/shared/page_title';
import { Box, Button, Stack } from '@mui/material';
import DataConfirmation from 'components/shared/data_confirmation';
import { FormButton, FormButtonType } from 'components/shared/form_button';
import { SnackbarFeedback } from 'components/shared/snackbar_feedback';
import { Modal } from 'components/shared/modal';
import { useConfirmData } from './useConfirmData';
import { useNavigate } from 'react-router-dom';
import {
  FormName,
  GetAnswersPayload,
  PostAnswersPayload,
} from 'api/answers/dtos/answers.dto';
import { getAnswersSchoolFeeding, putAnswers } from 'api/answers/answers.api';

const EditConfirmSchoolFeeding: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [sucessModal, setSucessModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();
  const [id, setId] = useState<string>();
  const data = useConfirmData();

  const handleSubmit = async () => {
  setLoading(true);
  const userAccessUuid = localStorage.getItem('userAccessUuid') ?? '';
  const institutionUuid = localStorage.getItem('institutionUuid') ?? '';

  const forms: PostAnswersPayload[] = [
    {
      formName: FormName.ALIMENTACAO_ESCOLAR_MUNICIPAL,
      referencedYear: 2025,
      userAccessUuid,
      institutionUuid,
      answer: {
        valueProvidedByPnae:
          parseFloat(data.municipalProvided.replace(/[^\d.-]/g, '')) || 0,
        valueAppliedByPnaeResource:
          parseFloat(data.municipalApplied.replace(/[^\d.-]/g, '')) || 0,
        productAquiredFromCnpjByPnaeResourceList: data.municipalCnpjProducts,
        productAquiredFromCpfByPnaeResourceList: data.municipalCpfProducts,
      },
    },
    {
      formName: FormName.ALIMENTACAO_ESCOLAR_ESTADUAL,
      referencedYear: 2025,
      userAccessUuid,
      institutionUuid,
      answer: {
        valueProvidedByPnae:
          parseFloat(data.stateProvided.replace(/[^\d.-]/g, '')) || 0,
        valueAppliedByPnaeResource:
          parseFloat(data.stateApplied.replace(/[^\d.-]/g, '')) || 0,
        productAquiredFromCnpjByPnaeResourceList: data.stateCnpjProducts,
        productAquiredFromCpfByPnaeResourceList: data.stateCpfProducts,
      },
    },
    {
      formName: FormName.ALIMENTACAO_ESCOLAR_FEDERAL,
      referencedYear: 2025,
      userAccessUuid,
      institutionUuid,
      answer: {
        valueProvidedByPnae:
          parseFloat(data.federalProvided.replace(/[^\d.-]/g, '')) || 0,
        valueAppliedByPnaeResource:
          parseFloat(data.federalApplied.replace(/[^\d.-]/g, '')) || 0,
        productAquiredFromCnpjByPnaeResourceList: data.federalCnpjProducts,
        productAquiredFromCpfByPnaeResourceList: data.federalCpfProducts,
      },
    },
  ];

  if (id) {
    try {
      for (const payload of forms) {
        await putAnswers(payload, id);
      }

      setSucessModal(true);
    } catch (error) {
      console.error(error);
      setErrorMessage(
        'Erro ao enviar os dados da Alimentação Escolar (Federal, Estadual ou Municipal).',
      );
    } finally {
      setLoading(false);
    }
  }
};


  useEffect(() => {
  const fetchData = async () => {
    const userAccessUuid = localStorage.getItem('userAccessUuid') ?? '';
    const institutitonUuid = localStorage.getItem('institutionUuid') ?? '';
    const payload: GetAnswersPayload = {
      userAccessUuid,
      institutitonUuid,
      referencedYear: 2025,
    };

    try {
      const response = await getAnswersSchoolFeeding(payload);
      const form = response?.data.find(
        (form: any) => form.formName === 'ALIMENTAÇÃO ESCOLAR MUNICIPAL'
      );
      if (form) {
        setId(form?.uuid);
      }
    } catch (error) {
      setErrorMessage(
        'Erro ao recuperar os dados da Aba Alimentação Escolar (Municipal).'
      );
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, []);


  return (
    <ContainerPainel
      pagina='CIFA - Editar Município - 2025'
      showBackButton={true}
      backButtonPath={ROUTES.CREATE_MUNICIPAL_SCHOOL_FEEDING_2025}
    >
      <HorizontalStepper activeStep={5} />

      <PageTitle
        title='Confirmação de Dados'
        subtitle='Confirme todas as informações que foram preenchidas, e altere-as caso necessário.'
      />

      <Stack marginX='4rem'>
        <DataConfirmation
          title='Assistência Técnica e Extensão Rural'
          subData={data.aterMunicipalPartnerList.map((partner: any) => ({
            data: [
              {
                title: `${partner.name.toUpperCase()} - Dados da parceria com a Instituição (ATER)`,
              },
              {
                label:
                  'Quantos beneficiários da Agricultura Familiar (unidade agro familiar) foram atendidos com ATER realizada pela instituição parceira no Município?',
                value: `${partner.numberOfBeneficiary}`,
              },
            ],
            ata: [
              {
                titlePDF: partner.partnershipDocument?.name,
                fileName: partner.partnershipDocument?.name,
                fileSize: '---',
                label: 'Documento de Formalização da Parceria',
                onView: () =>
                  partner.partnershipDocument?.uuid &&
                  window.open(`/files/${partner.partnershipDocument.uuid}`),
              },
              {
                titlePDF: partner.ataCmdrsDocument?.name,
                fileName: partner.ataCmdrsDocument?.name,
                fileSize: '---',
                label: 'Ata do CMDRS',
                onView: () =>
                  partner.ataCmdrsDocument?.uuid &&
                  window.open(`/files/${partner.ataCmdrsDocument.uuid}`),
              },
            ],
          }))}
        />

        <DataConfirmation
          title='Resumo'
          data={[
            {
              label:
                'Quantos beneficiários da Agricultura Familiar (unidade agro familiar) foram atendidos com ATER realizada exclusivamente pelo Município?',
              value: `${Number(data.aterExclusiveServiceMunicipality)}`,
            },
            {
              label:
                'Foi realizada parceria com instituição para execução da ATER?',
              value: data.aterServiceByMunicipalPartner ? 'Sim' : 'Não',
            },
            {
              label: 'Instituições parceiras:',
              value: data.aterMunicipalPartnerList
                .map((partner: any) => partner.name.toUpperCase())
                .join(', '),
            },
          ]}
        />

        <DataConfirmation
          title='Alimentação Escolar (PNAE Federal)'
          data={[
            {
              label: 'Valor disponibilizado pelo PNAE Federal:',
              value: `R$ ${Number(data.federalProvided).toLocaleString(
                'pt-BR',
              )}`,
            },
            {
              label:
                'Valores totais aplicados pelo município na Alimentação Escolar oriundos de todo e qualquer fornecedor no ano de 2024:',
              value: `R$ ${Number(data.federalApplied).toLocaleString(
                'pt-BR',
              )}`,
            },
          ]}
          dataProduct={[
            {
              title:
                'Produtos adquiridos via CNPJ (com recurso do PNAE Federal) - Valores Aplicados na Aquisição de Produtos',
              data: data.federalCnpjProducts.map((prod: any) => ({
                name: prod.name,
                cnpjOrcpf: prod.identification,
                value: `R$ ${Number(prod.value).toLocaleString('pt-BR')}`,
              })),
            },
            {
              title:
                'Produtos adquiridos via CPF (com recurso do PNAE Federal) - Valores Aplicados na Aquisição de Produtos',
              data: data.federalCpfProducts.map((prod: any) => ({
                name: prod.name,
                cnpjOrcpf: prod.identification,
                value: `R$ ${Number(prod.value).toLocaleString('pt-BR')}`,
              })),
            },
          ]}
        />

        <DataConfirmation
          title='Alimentação Escolar (Governo Estadual)'
          data={[
            {
              label: 'Valor disponibilizado pelo Governo Estadual:',
              value: `R$ ${Number(data.stateProvided).toLocaleString('pt-BR')}`,
            },
            {
              label:
                'Valores totais aplicados pelo município na Alimentação Escolar oriundos de todo e qualquer fornecedor no ano de 2024:',
              value: `R$ ${Number(data.stateApplied).toLocaleString('pt-BR')}`,
            },
          ]}
          dataProduct={[
            {
              title:
                'Produtos adquiridos via CNPJ (com recurso do Governo Estadual)',
              data: data.stateCnpjProducts.map((item: any) => ({
                name: item.name,
                cnpjOrcpf: item.identification,
                value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
              })),
            },
            {
              title:
                'Produtos adquiridos via CPF (com recurso do Governo Estadual)',
              data: data.stateCpfProducts.map((item: any) => ({
                name: item.name,
                cnpjOrcpf: item.identification,
                value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
              })),
            },
          ]}
        />

        <DataConfirmation
          title='Alimentação Escolar (Prefeitura)'
          data={[
            {
              label: 'Valor disponibilizado pelo Prefeitura:',
              value: `R$ ${Number(data.municipalProvided).toLocaleString(
                'pt-BR',
              )}`,
            },
            {
              label:
                'Valores totais aplicados pelo município na Alimentação Escolar oriundos de todo e qualquer fornecedor no ano de 2024:',
              value: `R$ ${Number(data.municipalApplied).toLocaleString(
                'pt-BR',
              )}`,
            },
          ]}
          dataProduct={[
            {
              title: 'Produtos adquiridos via CNPJ (com recurso do Prefeitura)',
              data: data.municipalCnpjProducts.map((item: any) => ({
                name: item.name,
                cnpjOrcpf: item.identification,
                value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
              })),
            },
            {
              title: 'Produtos adquiridos via CPF (com recurso do Prefeitura)',
              data: data.municipalCpfProducts.map((item: any) => ({
                name: item.name,
                cnpjOrcpf: item.identification,
                value: `R$ ${Number(item.value).toLocaleString('pt-BR')}`,
              })),
            },
          ]}
        />
      </Stack>

      {/* Botões */}
      <Box
        display='flex'
        justifyContent='center'
        alignItems='center'
        gap={2}
        marginTop='20px'
      >
        <Button
          variant='text'
          sx={{
            color: '#1976D2',
            fontWeight: 'bold',
            textTransform: 'uppercase',
          }}
          onClick={() => navigate(ROUTES.CIFA2025)}
        >
          Voltar
        </Button>

        <Button
          variant='contained'
          onClick={handleSubmit}
          disabled={loading}
          sx={{
            backgroundColor: '#0048B6',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            '&:hover': {
              backgroundColor: '#003399',
            },
          }}
        >
          Confirmar e salvar
        </Button>
      </Box>
      <Modal
        open={sucessModal}
        onClose={() => navigate(ROUTES.CIFA2025)}
        title='Sucesso ao cadastrar munícipio!'
        subTitle='O município foi cadastrado com o sucesso no CIFA 2025'
        buttons={[
          <FormButton
            key={1}
            type={FormButtonType.PRIMARY}
            title='Voltar para a tela inicial'
            onClick={() => navigate(ROUTES.CIFA2025)}
          />,
        ]}
      />
      {errorMessage && (
        <SnackbarFeedback isOpen type='error' message={errorMessage} />
      )}
    </ContainerPainel>
  );
};

export default EditConfirmSchoolFeeding;
